import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Portfolios, PortfoliosAdd, PortfoliosEdit } from '../../../pages';
import PortfoliosProvider from '../../../contexts/PortfolioContext';

const PortfoliosRoutes = () => {
  return (
    <PortfoliosProvider>
      <Routes>
        <Route path={`:id`} element={<PortfoliosEdit />} />
        <Route path={`add`} element={<PortfoliosAdd />} />
        <Route path="" element={<Portfolios />} />
      </Routes>
    </PortfoliosProvider>
  );
};

export default PortfoliosRoutes;
